import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  playedChapter: null,
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'chapters',
  initialState,
  reducers: {
    initialStateAction: () => initialState,
    setPlayedChapterAction: (state, action) => {
      state.playedChapter = action.payload;
    },
  },
});

export const { initialStateAction, setPlayedChapterAction } = slice.actions;
